import { render, staticRenderFns } from "./initiatecollection.vue?vue&type=template&id=74825763"
import script from "./initiatecollection.vue?vue&type=script&lang=js"
export * from "./initiatecollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports